// Campaign templates → one-click prompts for the AI Marketing Director
export const CAMPAIGN_TEMPLATES = [
  { l: "Product Launch", p: "Create a product launch campaign for my newest product" },
  { l: "New Arrival", p: "Announce a new arrival and drive first-week sales" },
  { l: "Best Seller", p: "Promote my best seller with social proof and urgency" },
  { l: "Flash Sale", p: "Run a 24-hour flash sale with a bold discount" },
  { l: "Weekend Sale", p: "Run a weekend sale this Saturday and Sunday" },
  { l: "Limited Time Offer", p: "Promote a limited-time offer with countdown urgency" },
  { l: "Father's Day", p: "Create a Father's Day gift campaign" },
  { l: "Mother's Day", p: "Create a Mother's Day gift campaign" },
  { l: "Memorial Day", p: "Create a Memorial Day weekend sale campaign" },
  { l: "Independence Day", p: "Create a 4th of July campaign with patriotic theme" },
  { l: "Labor Day", p: "Create a Labor Day weekend sale campaign" },
  { l: "Halloween", p: "Create a spooky Halloween promotion" },
  { l: "Thanksgiving", p: "Create a Thanksgiving gratitude + sale campaign" },
  { l: "Black Friday", p: "Create a Black Friday doorbuster sale campaign" },
  { l: "Small Business Saturday", p: "Create a Small Business Saturday support-local campaign" },
  { l: "Cyber Monday", p: "Create a Cyber Monday online-only deals campaign" },
  { l: "Christmas", p: "Create a Christmas gift + holiday campaign" },
  { l: "New Year's", p: "Create a New Year's fresh-start campaign" },
  { l: "Valentine's Day", p: "Create a Valentine's Day gift campaign" },
  { l: "Spring", p: "Create a Spring seasonal refresh campaign" },
  { l: "Summer", p: "Create a Summer seasonal campaign" },
  { l: "Fall", p: "Create a cozy Fall seasonal campaign" },
  { l: "Winter", p: "Create a Winter seasonal campaign" },
];

// Seasonal events (month is 0-indexed). Fixed-date holidays for the planner.
export const SEASONAL_EVENTS = [
  { l: "Valentine's Day", m: 1, d: 14, p: "Create a Valentine's Day gift campaign" },
  { l: "Memorial Day", m: 4, d: 26, p: "Create a Memorial Day weekend sale campaign" },
  { l: "Father's Day", m: 5, d: 15, p: "Create a Father's Day gift campaign" },
  { l: "Mother's Day", m: 4, d: 11, p: "Create a Mother's Day gift campaign" },
  { l: "Independence Day", m: 6, d: 4, p: "Create a 4th of July campaign with patriotic theme" },
  { l: "Labor Day", m: 8, d: 1, p: "Create a Labor Day weekend sale campaign" },
  { l: "Halloween", m: 9, d: 31, p: "Create a spooky Halloween promotion" },
  { l: "Thanksgiving", m: 10, d: 27, p: "Create a Thanksgiving gratitude + sale campaign" },
  { l: "Black Friday", m: 10, d: 28, p: "Create a Black Friday doorbuster sale campaign" },
  { l: "Cyber Monday", m: 11, d: 1, p: "Create a Cyber Monday online-only deals campaign" },
  { l: "Christmas", m: 11, d: 25, p: "Create a Christmas gift + holiday campaign" },
  { l: "New Year's", m: 0, d: 1, p: "Create a New Year's fresh-start campaign" },
];

export function upcomingEvents(limit = 5) {
  const now = new Date();
  const year = now.getFullYear();
  return SEASONAL_EVENTS
    .map((e) => {
      let dt = new Date(year, e.m, e.d);
      if (dt < now) dt = new Date(year + 1, e.m, e.d);
      return { ...e, date: dt };
    })
    .sort((a, b) => a.date - b.date)
    .slice(0, limit);
}
